import { ChainId } from '@pancakeswap/sdk'
import { ComputedFarmConfigV3 } from '../../src/types'

import { farmsV3 as farm5000 } from '../5000'
import { farmsV3 as farm5003 } from '../5003'


export const farmsV3ConfigChainMap: Record<ChainId, ComputedFarmConfigV3[]> = {
  [ChainId.MANTLE]: farm5000,
  [ChainId.MANTLE_TESTNET]: farm5003,
}
